import React from 'react';
import {
    Box,
    Tooltip,
    IconButton,
    Typography,
    Divider,
    Table, 
    TableBody, 
    TableRow, 
    TableCell, 
} from '@mui/material';
import {
    Security as SecurityIcon,
} from '@mui/icons-material';

const PRIORITY_ORDER = ['ADMIN', 'WRITE', 'READ'];

// Color segun permiso
const getPermissionColor = (permissionLevel) => {
    const level = (permissionLevel || '').toUpperCase();
    switch (level) {
        case 'ADMIN': return '#F44336';
        case 'WRITE': return '#FF9800';
        case 'READ': return '#4CAF50';
        default: return '#9e9e9e';
    }
};

const RoleIconField = ({ record }: any) => {
    if (!record || !record.rolePermissions || record.rolePermissions.length === 0) {
        return (
            <Typography variant='caption' color='text.secondary' sx={{ fontStyle: 'italic',  }}>
                Sin roles
            </Typography>
        );
    }

    const rolePermissions = record.rolePermissions || [];

    // Ordenar los permisos: ADMIN > WRITE > READ
    const sortedPermissions = [...rolePermissions].sort((a, b) => {
        const aIndex = PRIORITY_ORDER.indexOf((a.permissionLevel || '').toUpperCase());
        const bIndex = PRIORITY_ORDER.indexOf((b.permissionLevel || '').toUpperCase());
        return aIndex - bIndex;
    });

    
    const tooltipTitle = (
        <Box>
            <Typography variant='subtitle2' sx={{ lineHeight: 1.2, mb: 0.5, textAlign: 'center', color: 'white' }}>
                Roles y Niveles de Permiso:
            </Typography>
            <Divider sx={{ my: 0.5, borderColor: 'rgba(255, 255, 255, 0.2)' }} />
            
            <Table size="small" sx={{ 
                minWidth: 150, 
                // Estilo de la abla como el tooltip
                '& .MuiTableCell-root': { 
                    borderBottom: 'none', 
                    padding: '4px 8px', 
                    color: 'white', 
                },
                '& .MuiTableBody-root': { backgroundColor: 'transparent' },
                '& .MuiTable-root': { backgroundColor: 'transparent' },
            }}>
                <TableBody>
                    {sortedPermissions.map((rp, i) => (
                        <TableRow key={i}>
                            {/* Celda del color */}
                            <TableCell sx={{ width: '10px', paddingRight: '4px !important' }}>
                                <Box
                                    sx={{
                                        width: 8,
                                        height: 8,
                                        borderRadius: '50%',
                                        backgroundColor: getPermissionColor(rp.permissionLevel),
                                        flexShrink: 0,
                                    }}
                                />
                            </TableCell>
                            
                            {/* Celda nombre del rol */}
                            <TableCell sx={{ fontWeight: 'bold', paddingLeft: '4px !important' }}>
                                <Typography variant='caption' sx={{ lineHeight: 1.2, fontWeight: 'bold', color: 'inherit' }}>
                                    {rp.role}
                                </Typography>
                            </TableCell>

                            {/* Celda nivel de permiso */}
                            <TableCell align="right" sx={{ paddingLeft: '4px !important' }}>
                                <Typography variant='caption' sx={{ lineHeight: 1.2, color: 'inherit' }}>
                                    ({rp.permissionLevel})
                                </Typography>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>

        </Box>
    );


    return (

        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
            }}
        >
            <Tooltip
                title={tooltipTitle}
                arrow
                placement='top'
                componentsProps={{
                    tooltip: {
                        sx: {
                            boxShadow: '0 0 10px rgba(2, 2, 2, 0.8), 0 8px 16px rgba(0, 0, 0, 0.3)',
                            py: 1.5,
                            px: 1.5,
                            borderRadius: '8px',
                            maxWidth: '500px',
                        },
                    },
                    arrow: {
                        sx: {
                            color: 'primary.main', 
                        }
                    }
                }}
            >
                <IconButton size='small' sx={{ padding: '2px', }}>
                    <SecurityIcon fontSize='small' color='primary' />
                </IconButton>
            </Tooltip>
        </Box>
    );
};

export default RoleIconField;
